import { useCallback } from 'react';
import { ComponentPadding, Container, DensitySpacing, Orientation, Typography, TypographyVariant } from '@tcc/fds';
import { RegionReportItemsValue } from './RegionReportItemsValue';
import type { RootLevelDetails } from '../container/types/modals';
import { getDisplayItem } from './displayFormatting';
import { SetItemCallback } from '../container/useRegionReportController';

export type YieldReportStatsLabelProps = {
  dataTestId: string;
  item: RootLevelDetails;
  onClickItem?: SetItemCallback;
  index: number;
  cropCode: string;
  cropNominalWeight?: number;
  isArdData: boolean;
};

export const YieldReportStatsLabel = ({
  dataTestId,
  index,
  item,
  onClickItem,
  cropCode,
  cropNominalWeight,
  isArdData
}: YieldReportStatsLabelProps) => {
  const { averageYield, area, label, cropNominalWeight: displayCropNominalWeight } = getDisplayItem(item);
  const openDetails = useCallback(() => onClickItem?.(item), [item, onClickItem]);
  const hasOpenDetails = !!onClickItem;
  
  return (
    <Container
      testId={`frr-region-report-${dataTestId}-item`}
      key={`dmb-region-report-item-${label}`}
      width='100%'
      orientation={Orientation.Horizontal}
      padding={DensitySpacing.Related}
      gap={DensitySpacing.None}
      >
      <Container
        orientation={Orientation.Horizontal}
        width='50%'
        padding={ComponentPadding.None}
      >
        <Typography variant={TypographyVariant.Label} testId={`dmb-region-report-${dataTestId}-label`}>
          {label}
        </Typography>
      </Container>

      <RegionReportItemsValue 
        area={area} 
        averageYield={averageYield} 
        dataTestId={dataTestId} 
        index={index}
        cropCode={cropCode}
        cropNominalWeight={displayCropNominalWeight === undefined ? cropNominalWeight : displayCropNominalWeight}
        onClick={hasOpenDetails ? openDetails : undefined}
        isArdData={isArdData} 
      />
    </Container>
  );
};